module.exports = __webpack_public_path__ + "static/media/specifics-bottom.aa71bbf9.png";